import React from 'react'
import { useGlobalLabels } from '@sentecacommerce-theme/lib'
import { Medium, OfficeOrAddressContainer } from '../..'
import { Typography } from '../../../../'

interface Props {
  office: any
}

export const OfficePreview = ({ office }: Props) => {
  const { address } = useGlobalLabels()
  return (
    <>
      <Medium>{`${address?.office}:`}</Medium>
      <OfficeOrAddressContainer>
        <Typography>{office?.name}</Typography>
      </OfficeOrAddressContainer>
    </>
  )
}
